@if (isChecked) {
  <div
    class="checkbox-container checked"
    >
    <i class="fa-solid fa-circle-check"></i>
    @if (label) {
      <label>{{label}}</label>
    }
  </div>
}
@if (!isChecked) {
  <div
    class="checkbox-container"
    >
    <i class="fa-regular fa-circle-xmark"></i>
    @if (label) {
      <label>{{label}}</label>
    }
  </div>
}
